/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { atanDependencies } from './dependenciesAtan.generated.js';
import { bignumberDependencies } from './dependenciesBignumber.generated.js';
import { columnDependencies } from './dependenciesColumn.generated.js';
import { complexDependencies } from './dependenciesComplex.generated.js';
import { cosDependencies } from './dependenciesCos.generated.js';
import { diagDependencies } from './dependenciesDiag.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { dotDependencies } from './dependenciesDot.generated.js';
import { equalDependencies } from './dependenciesEqual.generated.js';
import { flattenDependencies } from './dependenciesFlatten.generated.js';
import { imDependencies } from './dependenciesIm.generated.js';
import { invDependencies } from './dependenciesInv.generated.js';
import { largerDependencies } from './dependenciesLarger.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { matrixFromColumnsDependencies } from './dependenciesMatrixFromColumns.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated.js';
import { numberDependencies } from './dependenciesNumber.generated.js';
import { qrDependencies } from './dependenciesQr.generated.js';
import { reDependencies } from './dependenciesRe.generated.js';
import { sinDependencies } from './dependenciesSin.generated.js';
import { smallerDependencies } from './dependenciesSmaller.generated.js';
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { usolveDependencies } from './dependenciesUsolve.generated.js';
import { usolveAllDependencies } from './dependenciesUsolveAll.generated.js';
import { createEigs } from '../../factoriesAny.js';
export var eigsDependencies = {
  absDependencies,
  addDependencies,
  addScalarDependencies,
  atanDependencies,
  bignumberDependencies,
  columnDependencies,
  complexDependencies,
  cosDependencies,
  diagDependencies,
  divideScalarDependencies,
  dotDependencies,
  equalDependencies,
  flattenDependencies,
  imDependencies,
  invDependencies,
  largerDependencies,
  matrixDependencies,
  matrixFromColumnsDependencies,
  multiplyDependencies,
  multiplyScalarDependencies,
  numberDependencies,
  qrDependencies,
  reDependencies,
  sinDependencies,
  smallerDependencies,
  sqrtDependencies,
  subtractDependencies,
  typedDependencies,
  usolveDependencies,
  usolveAllDependencies,
  createEigs
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesEigs.generated.js
// module id = TUZg
// module chunks = 3